<!-- Copyright (c) 2025 MOCA Systems, Inc. All rights reserved. -->
<dialog-titlebar [title]="appStrings.IMAGE_COLLECTION_TITLE"></dialog-titlebar>
<mat-dialog-content class="image-collection-dialog-content">
	<ng-template
		[loadingBlocker]="isLoading$ | async"
		[transparent]="false"
		[customContent]="loadingBlockerCustomContent"
	>
	</ng-template>
	<ng-template #loadingBlockerCustomContent>
		<div class="loading-container">
			<p *ngIf="isUploading$ | async" automationId="loading">{{ appStrings.IMAGE_COLLECTION_LOADING_UPLOADING }}</p>
			<p *ngIf="isProcessing$ | async">{{ appStrings.IMAGE_COLLECTION_LOADING_PROCESSING }}</p>
			<p *ngIf="isProcessing$ | async" automationId="loadingPercentage">
				{{ appStrings.IMAGE_COLLECTION_LOADING_PROCESSING_PERCENTAGE(processingProgress$ | async) }}
			</p>
		</div>
	</ng-template>
	<p>{{ appStrings.IMAGE_COLLECTION_DESCRIPTION }}</p>
	<form [formGroup]="imageCollectionForm">
		<div class="form-fields">
			<mat-form-field subscriptSizing="dynamic">
				<mat-label>{{ appStrings.IMAGE_COLLECTION_PLAN_START_DATE_FIELD_LABEL }}</mat-label>
				<input
					matInput
					readonly
					[matDatepicker]="planStartDatePicker"
					automationId="planStartDateField"
					formControlName="planStartDate"
					(click)="planStartDatePicker.open()"
				/>
				<mat-datepicker-toggle
					automationId="planStartDatePicker"
					matSuffix
					[for]="planStartDatePicker"
				></mat-datepicker-toggle>
				<mat-datepicker touchUi #planStartDatePicker></mat-datepicker>
			</mat-form-field>
			<tp-file-upload
				#fileInput
				formControlName="files"
				[buttonText]="'upload'"
				[placeholder]="'Choose file'"
				[outputFormat]="UploadOutputFormat.File"
				[allowMultiple]="true"
				[acceptedFileTypes]="acceptedFileTypes"
			>
				<ng-template fileUploadCustomSlot>
					<button mat-stroked-button color="primary" automationId="uploadMoreButton" class="upload-more-button">Upload More</button>
				</ng-template>
			</tp-file-upload>
		</div>
	</form>
	<!-- Hidden File Field for the Replace functionality -->
	<input
		#replaceFileInput
		type="file"
		hidden
		[accept]="acceptedFileTypes"
		(multiple)="(false)"
		(change)="replaceFileInputChange($event)"
	/>

	<div class="upload-list" automationId="uploadList" cdkDropList (cdkDropListDropped)="doReorder($event)">
		<div class="upload-item" *ngFor="let file of files" cdkDrag>
			<mat-icon>drag_handle</mat-icon>
			<div class="thumbnail-wrapper" [class.error]="file.error">
				<img [src]="file.thumbnailUrl" alt="{{ file.name }}" />
			</div>

			<div class="file-info">
				<div class="file-name" automationId="fileInfo">{{ file.name }}</div>
				<div *ngIf="!file.error; else imageError" class="start-date">
					{{ appStrings.IMAGE_COLLECTION_FILE_START_DATE }} {{ file.startDate }}
				</div>
				<ng-template #imageError>
					<div class="file-error">
						<mat-icon class="warning-icon" automationId="invalidFileWarning">warning</mat-icon>
						{{ file.error }}
					</div>
				</ng-template>
			</div>

			<div class="actions">
				<button (click)="removeFile(file)" mat-icon-button automationId="removeFile" class="remove-button">
					<mat-icon>close</mat-icon>
				</button>
				<div class="action-buttons">
					<button (click)="previewFile(file)" automationId="previewFile" mat-button>
						<mat-icon>visibility</mat-icon>
						Preview
					</button>
					<button
						automationId="replaceFile"
						(click)="replaceFile(file, replaceFileInput)"
						mat-button
						[ngClass]="{ 'highlight-replace': file.error }"
					>
						<mat-icon>autorenew</mat-icon>
						Replace
					</button>
				</div>
			</div>
		</div>
	</div>

	<!-- <button (click)="simulateCompleted()">Sim Completed</button> -->
	<!-- <button (click)="simulateFailed()">Sim Failed</button> -->
	<!-- <button (click)="simulateSingleFileFailed()">Sim Single File Failed</button> -->
	<!-- <button (click)="simulateIsUploading()">Sim Uploading</button> -->
	<!-- <button (click)="simulateIsProcessing()">Sim Processing</button> -->
</mat-dialog-content>

<mat-divider class="padded-divider"></mat-divider>
<button-footer
	mat-dialog-actions
	[saveOrCloseButtonText]="appStrings.IMAGE_COLLECTION_SAVE_OR_CLOSE_BUTTON"
	(buttonSaveOrClose)="uploadFiles()"
></button-footer>
